"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
function useProjectItemPath(projectId) {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    return pathname === `/projects/${projectId}`;
}
exports.default = useProjectItemPath;
